import { render, staticRenderFns } from "./InputNewContact.vue?vue&type=template&id=048e9903"
import script from "./InputNewContact.vue?vue&type=script&lang=js"
export * from "./InputNewContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports